import * as ActionTypes from '../ActionTypes';

// Module
export const GetATSModuleFeaturesAction = (params) => {
    return {
        type: ActionTypes.ATS_MODULE_FEATURES_GET_REQUEST,
        params
    }
}